import { render } from "./CurrentWorkingHours.vue?vue&type=template&id=e8790342&lang=pug"
import script from "./CurrentWorkingHours.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentWorkingHours.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__